<template>
  <div class="ServicesList">
    <div
      class="header w100 fff d-flex j-sb"
      style="height:54px;padding:0 12px;font-size:0.875rem; !important"
    >
      <div class="d-flex a-center j-center h100" style="line-height: 54px">
        <div class="main-text-color h100"></div>
        <div class="h100 d-flex" style="margin-left: 40px; font-size: 16px">
          <!-- <i class="el-icon-s-custom"></i>欢迎您，管理员 -->
          <div style="margin-right: 40px">会议时间：{{ startTime }}</div>
          <div>会议主题：{{ activityName }}</div>
        </div>
      </div>
    </div>
    <div>
      <div class="box">
        <!-- =================================================tab表格区域============================================================== -->
        <div class="d-flex j-sb p-top-2 p-right-4">
          <div class="d-flex">
            <santakinput   
              v-if="true"                 
              santakLabel="公司名称："
              fieldName="companyName"
              :defaultValue="queryInfo.companyName"
              field="queryInfo"
              width="150"
              label-width="120"
            ></santakinput>
            <santakinput
              santakLabel="姓名："
              fieldName="name"
              field="queryInfo"
              width="150"
              labelWidth="120"
              :defaultValue="queryInfo.name"
            ></santakinput>

            <santakinput
              santakLabel="手机号码："
              fieldName="tel"
              field="queryInfo"
              width="150"
              labelWidth="120"
              :defaultValue="queryInfo.tel"
            ></santakinput>
          </div>
          <div>
            <santakButton
              title="查询"
              @clickHandle="searchByConditions"
            ></santakButton>
            <santakButton
              title="导出"
              @clickHandle="excelExport"
            ></santakButton>
            <santakButton
              title="返回活动列表"
              @clickHandle="$router.back()"
            ></santakButton>
          </div>
        </div>
        <el-table
          border
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; margin: 20px 0"
        >
          <el-table-column
            v-if="true"
            show-overflow-tooltip
            align="center"
            prop="companyName"
            label="公司名称"
          >
          </el-table-column>

          <el-table-column show-overflow-tooltip align="center" label="姓名">
            <template #default="scope">
              <div>
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="tel"
            label="手机"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.tel }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="position"
            label="职务"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.position }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="email"
            label="邮箱"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.email }}
              </div>
            </template></el-table-column
          >
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop=""
            label="操作"
          >
            <template slot-scope="scope">
              <div>
                <el-button size="mini" @click="deleteSignUpOrIn(scope)"
                  >删除</el-button
                >
              </div>
            </template></el-table-column
          >
        </el-table>
        <!-- 编辑的dialog -->

        <!-- 分配请求 -->
        <div class="f-md main-text-color d-flex a-center" style="">
          <div class="fontsize">
            显示第 {{ startPagination }} 到第
            {{ endPagination > total ? total : endPagination }} 条记录,
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
        <!-- =================================================tab表格区域============================================================== -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryAllByActivityId, 
  excelexport as excelexportSignUp,
  deleteParticipants as deleteParticipantsSignUp,
} from "../../api/serviceRequestAdmin";

import mixins2 from "../../mixin/mixins2";
export default {
  name: "Manage",
  mixins: [mixins2],
  data() {
    return {
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        activityId: this.$route.query.activityId,
        companyName: "",
        name: "",
        tel: "",
      },
      tableData: [],
      total: null,
      endPagination: "",
      startPagination: "",
    };
  },
  mounted() {
    this.getTableData();
  },
  computed: {
    activityName() {
      return this.$route.query.activityName;
    },
    startTime() {
      return this.$route.query.startTime;
    },
  },
  methods: {
    // 查询
    query() {
      this.queryInfo.pageNum = 1;
      this.getTableData();
    },
    searchByConditions() {
      this.query();
    },
    reset() {
      let { pageNum, pageSize } = this.queryInfo;
      this.queryInfo = {
        pageNum: 1,
        pageSize,
        activityId: this.$route.query.activityId,
        companyName: "",
        name: "",
        tel: "",
      };
      this.getTableData();
    },
    // async excelExport() {
    //   let exportMethod = this.type === 0 ? excelexportSignUp : excelexportSignIn;
    //   const res = await excelexportSignUp({
    //     activityId: this.$route.query.activityId
    //   });
    //   if (res.status !== 200)
    //     return this.$message.error("未查询到数据，请检查后再试");
    //   window.open(res.result);
    // },
    handleSizeChange(size) {
      this.queryInfo.pageSize = size;
      this.getTableData();
    },
    handleCurrentChange(page) {
      console.log(page)
      this.queryInfo.pageNum = page;
      this.getTableData();
    },
    async getTableData() {
      let obj = Object.assign({}, this.queryInfo);
      try {
        const res = await queryAllByActivityId(obj);
        console.log(res);
        if (res.status == 200) {
          let { navigateFirstPage, navigateLastPage, total } = res.result;
          console.log(res.result)
          this.tableData = res.result.list;
          this.total = total;
          this.endPagination = navigateLastPage;
          this.startPagination = navigateFirstPage;


        }
      } catch (error) {}
    },
    //删除某嘉宾
    async deleteSignUpOrIn(scope) {
      try {
        await this.$confirm("确定删除该改嘉宾？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        const res = await deleteParticipantsSignUp(scope.row.id);
        if (res.status == 200) {
          this.$message.success("删除成功！");
          this.getTableData();
        }
      } catch (error) {
        this.$message("已取消");
      }
    },
  },
};
</script>

<style scoped lang="less" scoped>
.ServicesList /deep/ .el-form-item {
  margin-bottom: 0 !important;
}
.ServicesList .box /deep/ .el-dialog {
  width: 1038px !important;
}
.ServicesList .owner /deep/ .el-select {
  width: 17.1875rem !important;
  height: 46px !important;
}
.optionSelect /deep/ .el-select {
  width: 21.875rem !important;
  height: 46px !important;
}

.box {
  padding: 10px 12px;
}
.bgc {
  background: #eee !important;
  padding-bottom: 5px;
}
.red {
  color: #de1e23;
}
.el-icon-s-custom {
  font-size: 16px;
  margin-right: 10px;
}
</style>
